import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ProjectRequestModal from '../components/ProjectRequestModal';

const ProjectRequestContext = createContext(null);

export function ProjectRequestProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openProjectRequest = useCallback(() => setOpen(true), []);
  const closeProjectRequest = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ openProjectRequest, closeProjectRequest, isProjectRequestOpen: open }),
    [openProjectRequest, closeProjectRequest, open]
  );

  return (
    <ProjectRequestContext.Provider value={value}>
      {children}
      <ProjectRequestModal open={open} onClose={closeProjectRequest} />
    </ProjectRequestContext.Provider>
  );
}

export function useProjectRequest() {
  const context = useContext(ProjectRequestContext);
  if (!context) {
    throw new Error('useProjectRequest deve ser usado dentro de ProjectRequestProvider.');
  }
  return context;
}
